module.exports = __webpack_public_path__ + "static/media/menu-nine-box.7a298c05.svg";